import { render, staticRenderFns } from "./AiExtractClaimsModal.vue?vue&type=template&id=91262a84&scoped=true"
import script from "./AiExtractClaimsModal.vue?vue&type=script&lang=js"
export * from "./AiExtractClaimsModal.vue?vue&type=script&lang=js"
import style0 from "./AiExtractClaimsModal.vue?vue&type=style&index=0&id=91262a84&prod&scoped=true&lang=scss"
import style1 from "./AiExtractClaimsModal.vue?vue&type=style&index=1&id=91262a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91262a84",
  null
  
)

export default component.exports